import { Component, ChangeDetectionStrategy, Input, inject } from '@angular/core';
import { Clipboard } from '@angular/cdk/clipboard';
import { AlertService } from '@src/core/services';
import { TranslateService } from '@ngx-translate/core';
import { TuiSizeL, TuiSizeS, TuiSizeXS } from '@taiga-ui/core';

@Component({
  selector: 'app-copy-to-clipboard-button',
  templateUrl: './copy-to-clipboard-button.component.html',
  styleUrls: ['./copy-to-clipboard-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CopyToClipboardButtonComponent {
  private readonly clipboard = inject(Clipboard);
  private readonly alertService = inject(AlertService);
  private readonly translateService = inject(TranslateService);

  @Input() link = '';
  @Input() size: TuiSizeL | TuiSizeS | TuiSizeXS = 'l';

  copyLinkToClipboard() {
    if (this.clipboard.copy(this.link)) {
      this.alertService.success(
        this.translateService.instant('components.copyToClipboardButton.alerts.successes.copyLink'),
      );
    }
  }
}
